var _rect, _rect2, _rect3, _path, _path2, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNutrition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 30,
    fill: "#EAF8FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 31,
    width: 42,
    height: 62,
    rx: 12,
    fill: "white",
    stroke: "#1680D8",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 22,
    width: 28,
    height: 15,
    rx: 5,
    fill: "#1680D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 70c8-18 18-20 28-8-6 14-16 22-28 8Z",
    fill: "#55B96C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 71c11-3 18-10 23-18",
    stroke: "#32944D",
    strokeWidth: 3,
    fill: "none"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 49,
    width: 26,
    height: 8,
    rx: 4,
    fill: "#D9F2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutrition);
export default __webpack_public_path__ + "static/media/nutrition.d95ff00cdbaeb17ea364d05c5436ff5c.svg";
export { ForwardRef as ReactComponent };